import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { getConfig } from '@klpkonsern/appconfig';
import { Conditional } from '@klp/conditional';
import { useAppParams } from '@klp/core/app/useAppParams';
import { TrustedIframe } from '@klp/iframe';
import { Main } from '@klp/layout/Main';

import { clearMiljoprofilEnvVariables, MiljoprofilAccess } from '../config';

const useStyles = makeStyles(() => ({
    iframe: {
        paddingTop: '20px',
    },
}));

export const Miljoprofil: React.FC = () => {
    const classes = useStyles();
    const { selectedClient } = useAppParams();
    const { search } = useLocation();
    const byggNummer = new URLSearchParams(search).get('byggnummer') ?? '';

    useEffect(() => {
        return () => {
            if (selectedClient) {
                clearMiljoprofilEnvVariables();
            }
        };
    }, [selectedClient]);

    const filteredMiljoprofilLinkHandler = () => {
        const filteredLink = getConfig('WEBAPP_APP_MILJOPROFIL_LINK', '');

        if (selectedClient === undefined && !byggNummer) {
            return filteredLink;
        }

        const params = new URLSearchParams({
            byggnummer: byggNummer,
            kundenummer: String(selectedClient?.kundeNummer ?? ''),
        });

        return `${filteredLink}?${params.toString()}`;
    };

    return (
        <Main fullScreen={true}>
            <Conditional
                condition={MiljoprofilAccess()}
                /* eslint-disable-next-line react/jsx-no-useless-fragment */
                errorComponent={<Fragment />}
            >
                <TrustedIframe
                    src={filteredMiljoprofilLinkHandler()}
                    fullScreen={true}
                    className={classes.iframe}
                />
            </Conditional>
        </Main>
    );
};
